export const EMAILSETTING_DISPLAYED_COLUMNS = ['assetName', 'gatewayName', 'events', 'sendEmail', 'notification', 'csvfile', 'lastUpdated'];
export const EMAILSETTING_NOTIFICATION = {
  SET_EMAIL_NOTIFICATION_HIST_ERROR: 'Error while receiving Email Subscription settings',
  SET_EMAIL_NOTIFICATION_SAVE_ERROR: 'Error in updating Email Subscription settings. Please try again',
  SET_EMAIL_NOTIFICATION_SUCCESS: 'Email Subscription settings updated successfully',
  ALL: 'All',
  WITH: 'with',
  WITHOUT: 'without',
  PRIMARY: 'primary',
};
